module.exports = __webpack_public_path__ + "static/media/unregiste_payment.28440382.svg";